const appDetails = {
    webLink: "https://grainshark.graindiscovery.com",
    googlePlayLink: "https://play.google.com/store/apps/details?id=com.graindiscovery.grainadvisor.grainshark&hl=es_UY",
    appStoreLink: "https://apps.apple.com/ca/app/grainshark/id6503197858",
    landingPage: "futures",
    signUpButton: false
}

export default appDetails;